import { styled } from '@clickcease/cc-client-components-lib'

export const ClickCeaseCreditCardStyles = styled('div', {
  width: '300px',
  height: '185px',
  background: '$primaryGradient',
  borderRadius: '16px',
  margin: '$10 0px $12 0px',
  display: 'flex',
  flexDirection: 'column',
  color: '$white',
  justifyContent: 'space-around',

  ['> svg']: {
    transform: 'scale(0.8)',
  },
})

export const ClickCeaseCreditCardNumber = styled('div', {
  fontWeight: '$l',
  fontSize: '18px',
  textAlign: 'center',
})

export const ClickCeaseCreditCardBottom = styled('div', {
  display: 'flex',
  marginLeft: '$10',
  justifyContent: 'space-between',
  width: '212px',
})

export const ClickCeaseCreditCardProperty = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const ClickCeaseCreditCardPropertyTitle = styled('div', {
  fontWeight: '500',
  fontSize: '$sm',
  textAlign: 'right',
})

export const ClickCeaseCreditCardPropertyText = styled('div', {
  fontSize: '$sm',
  fontWeight: '$l',
})
